import React from 'react'
import { yupResolver } from '@hookform/resolvers/yup'

import { useControlledForm, useFormApiError, useFormReset } from 'hooks'
import {
  mapJobSeekerToInternalState,
  mapInternalStateToPayload,
} from './actions'
import { getDefaultValues } from './model'
import { getSchema } from './schema'

export const useJobSeekerModalForm = (state, handlers) => {
  const { candidate, languages, isOpen } = state
  const { onConfirm } = handlers

  const [apiError, setApiError] = React.useState(null)
  const [shouldReset, setShouldReset] = React.useState(false)

  const defaultValues = getDefaultValues(languages)
  const schema = getSchema()

  const internalState = mapJobSeekerToInternalState(candidate)

  const handleFormData = React.useCallback(
    data => {
      const payload = mapInternalStateToPayload(data)

      onConfirm(payload, {
        onError: setApiError,
        onSuccess: () => setShouldReset(true),
      })
    },
    [onConfirm],
  )

  const {
    control,
    formState,
    handleFormApiError,
    handleFormReset,
    handleFormSubmit,
    isDirtyOrInvalid,
  } = useControlledForm({
    values: candidate ? internalState : defaultValues,
    resolver: yupResolver(schema),
    handleFormData,
  })

  useFormApiError({ apiError }, handleFormApiError)
  useFormReset(
    { shouldReset: shouldReset && formState.isSubmitSuccessful },
    handleFormReset,
  )

  React.useEffect(() => {
    if (isOpen) {
      setShouldReset(false)
    }
  }, [isOpen])

  return {
    state: { control, formState, isDirtyOrInvalid },
    handlers: { handleFormReset, handleFormSubmit },
  }
}
